@if (store.isLoading()) {
  <mat-progress-bar mode="query"></mat-progress-bar>
}
<div class="base-entity-list mat-elevation-z8">
  <div class="base-entity-list-scroll">
    <table mat-table [dataSource]="dataSource" matSort aria-describedby="base-entity-list">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? onToggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"> </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null; onChangeSelection(row)" [checked]="selection.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      @for (colDescriptor of columnDescriptors(); track colDescriptor.attrName; let i = $index) {
        <ng-container [matColumnDef]="colDescriptor.attrName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [class.pp-col-autosize]="colDescriptor.autosizeColumn">{{ colDescriptor.i18nKey() | ppLabel: colDescriptor.label }}</th>
          <td mat-cell [class.pp-col-autosize]="colDescriptor.autosizeColumn" (click)="onRowClick(element)" (keydown.enter)="onRowClick(element)" tabindex="0" role="button" *matCellDef="let element">
            <span class="pp-cell-content">
              @if (colDescriptor.isLinkToDetails) {
                <a class="link-to-details" (click)="onNavigateToDetails(element)">{{
                  colDescriptor.formControlType === 'DATE' ? (element[colDescriptor.attrName] | ppDate: colDescriptor.dateFormat) : element[colDescriptor.attrName]
                }}</a>
              } @else if (colDescriptor.linkedEntityType !== undefined) {
                <a (click)="onNavigateToRelated(colDescriptor, element)">{{ foreignKeyLabel(colDescriptor, element) }}</a>
              } @else if ((colDescriptor.formControlType === 'ARTIFACT' || colDescriptor.formControlType === 'AVATAR') && element[colDescriptor.attrName] !== undefined && element[colDescriptor.attrName] !== null) {
                @for (artifact of artifactsOf(element[colDescriptor.attrName]); track $index; let last = $last) {
                  <a (click)="onDownloadObject(artifact, $event)">{{
                    (artifact.name || artifact.objectId | slice: 0 : 20) + ((artifact.name || artifact.objectId).length > 20 ? '...' : '')
                  }}</a
                  >@if (!last) {, }
                }
              } @else if (colDescriptor.formControlType === 'TAGS' && element[colDescriptor.attrName] !== undefined) {
                {{ (element[colDescriptor.attrName].join(', ') | slice: 0 : 20) + (element[colDescriptor.attrName].join(', ').length > 20 ? '...' : '') }}
              } @else if (colDescriptor.formControlType === 'ADDRESS') {
                {{ element[colDescriptor.attrName] | ppAddress }}
              } @else if (colDescriptor.formControlType === 'GEO_LOCATION') {
                {{ element[colDescriptor.attrName] | ppGeoLocation }}
              } @else if (colDescriptor.formControlType === 'COMMENTS') {
                {{ 'base_entity.comments.count' | transloco: { count: commentCount(element[colDescriptor.attrName]) } }}
              } @else if (colDescriptor.formControlType === 'DATE') {
                {{ element[colDescriptor.attrName] | ppDate: colDescriptor.dateFormat }}
              } @else {
                {{ element[colDescriptor.attrName] }}
              }
            </span>
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
    </table>
  </div>
  <div class="base-entity-list-footer">
    @if (selectOrCreateMode()) {
      <div class="base-entity-list-actions">
        <button id="cancel" [attr.data-testid]="entityDescriptor().createTestId('cancel')" type="button" mat-raised-button color="secondary" (click)="onCancelSelectOrCreate()">Cancel</button>
        <button id="select" [attr.data-testid]="entityDescriptor().createTestId('select')" type="button" mat-raised-button color="primary" [disabled]="!canSelectEntity()" (click)="onSelectEntity()">
          Select
        </button>
      </div>
    }
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
